<template>
  <div>
    <div v-if="Busy == true">
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </div>
    <div v-else>
        <h3>test</h3>
      
      <CCol sm="12">
        <CDataTable
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          :items="FilteredFee"
          :fields="fields"
          items-per-page-select
          :items-per-page="small ? 5 : 10"
          :dark="dark"
          clickable-rows
          sorter
          pagination
        >
          <template #Name="{ item }">
            <td>
             {{ item.Student.Name }}
            </td>
          </template>

          <template #ParentEmail="{ item }">
            <td>
                 {{ item.Student.ParentEmail }}
            </td>
          </template>

          <template #Amount="{ item }">
            <td>
            {{ item.RegistrationFee.Amount }}
            </td>
          </template>

          <template #Year="{ item }">
             <td>
                <li>{{  item.RegistrationFee.Year }}</li>
            </td>
          </template>

          <template #IsPaid="{ item }">
            <td>
              <div v-if="item.IsPaid === true">
                <CBadge color="success">Yes</CBadge>
              </div>
              <div v-else><CBadge color="danger">No</CBadge></div>
            </td>
          </template> -->

          <template #Action="{ item }">
            <td>
              <CDropdown toggler-text="Action" class="m-2 btn-act" color="primary">
                <CDropdownItem @click="OpenUpdate(item)">Edit</CDropdownItem>
                <CDropdownItem @click="OpenDelete(item)">Additional</CDropdownItem>
                 <CDropdownItem @click="OpenDelete(item)">Print</CDropdownItem>
              </CDropdown>
            </td>
          </template>
        </CDataTable>

      <CModal title="Learning Registration Fee" size="md" :show.sync="EditFee">
          <div>
            <h6><strong></strong></h6>
            <CRow>
              <CCol md="4">
                <strong>Student Name</strong>
              </CCol>
              <CCol md="8">
                <span>: {{ feeDetail.StudentName }}  </span>
              </CCol>
            </CRow>
             <CRow>
              <CCol md="4">
                <strong>Student Status</strong>
              </CCol>
              <CCol md="8">
                <span>: {{ feeDetail.Status }}  </span>
              </CCol>
            </CRow>
             <CRow>
              <CCol md="4">
                <strong>Total Fees</strong>
              </CCol>
              <CCol md="8">
                <span>:  {{ feeDetail.Amount }}  </span>
              </CCol>
            </CRow>
              <CRow>
              <CCol md="4">
                <strong>Year</strong>
              </CCol>
              <CCol md="8">
                <span>:  {{ feeDetail.Year }}  </span>
              </CCol>
            </CRow>
             <CRow>
              <CCol md="4">
                <strong>Is Paid</strong>
              </CCol>
              <CCol md="8">
                <span>:  {{ feeDetail.IsPaid }}  </span>
              </CCol>
            </CRow>
            <hr />
           <CRow>
              <CCol md="4">
                <strong>Is Paid</strong>
              </CCol>
              <CCol md="6">
               <v-select
              horizontal
              v-model="SelectedPaid"
              :options="[
                { label: 'Yes', id: 1 },
                { label: 'No', id: 0 },
              ]"
              placeholder="Select Paid"
            />
              </CCol>
            </CRow>
          </div>
          <template #footer>
            <CButton
              type="submit"
              class="p-2"
              color="info"
              @click="UpdateSetPayment()"
              >Proceed</CButton
            >
          </template>
        </CModal>
      </CCol>
    </div>
  </div>
</template>


<script>
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import $ from "jquery";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

export default {
  name: "Tables",
  components: {
    PulseLoader,
  },
  data() {
    return {
      fees: [],
      FilteredFee: [],

      Busy: false,
      EditFee: false,
      feeDetail: {},
      SelectedPaid: "",

      fields: [
        { key: "Name" },
        // { key: "Name" },
         { key: "ParentEmail" },
        { key: "Amount" },
        { key: "Year" },
        { key: "IsPaid" },
        { key: "Action" },
      ],
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetFee();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetFee() {
      this.Busy = true;
      this.$API
        .get(this.$GetRegistrationFee, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.fees = response.data;
            this.FilteredFee = this.fees;
          }
        });
    },
    OpenUpdate(item)
    {
      this.Id = item.Student.Id;
      this.Year = item.RegistrationFee.Year;
      this.FeeId = item.RegistrationFee.Id;
       this.$API
        .get(this.$GetDetailRegistrationFee + "?id=" + this.Id + "&year=" + this.Year, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.feeDetail = response.data;
          }
        });
      this.EditFee = true;
    },
    UpdateSetPayment: function () {
      const formData = new FormData();

      formData.append("Id", this.FeeId);
      formData.append("IsPaid", this.SelectedFee.id);

      return this.$API
        .post(this.$UpdateRegistrationFee, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.AdditionalModal = false;
            this.$dialog.alert("Success save").then(function () {});
            
          } else {
            this.Busy = false;
            this.$dialog.alert("Error").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });

    }
    
  },
};
</script>
<style>
.style-chooser .vs__open-indicator {
    fill: rgb(251 248 254);
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transition: -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
    transition: -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
    transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
    transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855), -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
    -webkit-transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
    transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}
.style-chooser .vs__clear {
    fill: rgb(251 248 254);
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    margin-right: 8px;
}
.style-chooser .vs__dropdown-toggle {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 0 0 4px 0;
    background: none;
    border: 1px solid #009efb;
    border-radius: 4px;
    white-space: normal;
    height: 36px;
}
.style-chooser .vs__selected {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #009efb;
    border: 1px solid #009efb;
    border-radius: 4px;
    color: #fff;
    line-height: 1.4;
    margin: 4px 2px 0px 2px;
    padding: 0 0.25em;
    z-index: 0;
}
.style-chooser .vs__single .vs__selected {
    background-color: #009efb;
    border-color: #009efb;
}
.custom-btn-blue{
  background: #009efb;
  border: 1px solid #009efb;
  color: #ffffff;
   border-radius: 4px;
}
.custom-btn-lgt {
    background: #7460ee;
    border: 1px solid #7460ee;
    color: #ffffff;
    width: 230px;
}
.btn-act {
    display: inline-block;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: #7460ee;
    border: 1px solid transparent;
    border-radius: 0.25rem;
}
.btn-primary {
    color: #fff;
    background-color: #7460ee;
    border-color: #7460ee;
}
.btn-primary:hover {
    color: #fff;
    background-color: #7460ee;
    border-color: #7460ee;
}
</style>
